import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { TextField as MuiTextField } from 'redux-form-material-ui';
import dateMask from '../../utils/masks/dateMask';

const ConfFormDateField = ({ name, label, disabled }) => (
  <Field
    disabled={disabled}
    name={name}
    label={label}
    fullWidth
    component={MuiTextField}
    {...dateMask}
  />
);

ConfFormDateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

ConfFormDateField.defaultProps = {
  disabled: false,
};

export default ConfFormDateField;
